import { LazyLoadedStatesManager } from "../class/lazy-loaded-states-manager.class";
import { LazyLoadedStates } from "../interfaces/lazy-loaded-states.interface";
import { AnecdotalObservationLazyLoadedStates } from "./anecdotal.lazy-loaded-states";
import { CustomFormsLazyLoadedStates } from "./custom-forms.lazy-loaded-states";
import { DiffLazyLoadedStates } from "./diff.lazy-loaded-states";
import { FormalLazyLoadedStates } from "./formal.lazy-loaded-states";
import { NtpeLazyLoadedStates } from "./ntpe.lazy-loaded-states";
import { RatingFormLazyLoadedStates } from "./rating.lazy-loaded-states";
import { RubricObservationLazyLoadedStates } from "./rubric.lazy-loaded-states";
import { SloObservationLazyLoadedStates } from "./slo.lazy-loaded-states";
import { SPMObservationLazyLoadedStates } from "./spm.lazy-loaded-states";
import { WalkthroughObservationLazyLoadedStates } from "./walkthrough.pre-states";

export const UserSummaryLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    view: LazyLoadedStates,
    obsSummary: LazyLoadedStates,
}> ({
    base: {
        name: 'authenticated.user-summary',
        url: '/user-summary',
    },
    view: {
        name: 'authenticated.user-summary.view',
        url: '/view/:userId?schoolYear&deleted',
    },
    obsSummary: {
        name: 'authenticated.user-summary.observation-summary',
        url: '/summary/:userId/:observationType?schoolYear&deleted',
    }
}, 
() => import('src/app/user-summary/user-summary.module')
    .then((result: {UserSummaryModule: any}) => result.UserSummaryModule),
[
    AnecdotalObservationLazyLoadedStates,
    CustomFormsLazyLoadedStates,
    DiffLazyLoadedStates,
    FormalLazyLoadedStates,
    NtpeLazyLoadedStates,
    RatingFormLazyLoadedStates,
    RubricObservationLazyLoadedStates,
    SloObservationLazyLoadedStates,
    SPMObservationLazyLoadedStates,
    WalkthroughObservationLazyLoadedStates
]
);
